import { type ReactNode } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { DropdownMenuItem } from "../shadcn/dropdown-menu";

export type ActionMenuItemProps = {
  title: string;
  icon?: ReactNode;
  onClick: () => void;
  className?: string;
  dataTestId?: string;
  disabled?: boolean;
};

export const ActionMenuItem = ({
  title,
  icon,
  onClick,
  className,
  dataTestId,
  disabled,
}: ActionMenuItemProps) => (
  <DropdownMenuItem
    className={cnTwMerge(
      "data-[highlighted]:ring-2 data-[highlighted]:ring-inset data-[highlighted]:ring-brand-default",
      className,
    )}
    data-testid={dataTestId}
    disabled={disabled}
    onClick={(e) => {
      e.stopPropagation();

      if (!disabled) onClick();
    }}
  >
    {icon}
    <p className="body-base-medium">{title}</p>
  </DropdownMenuItem>
);
